enum PackageCoverageAccessor {
  HomeCoverage = "coverageA.value",
  HomeCoverageSettlementType = "coverageA.settlementOption",
  YourBelongings = "coverageC.value",
  YourBelongingsSettlementType = "coverageC.settlementOption",
  OtherStructures = "coverageB.value",
  OtherStructuresSettlementType = "coverageB.settlementOption",
  StandardDeductible = "deductibles.allOtherPerilsDeductible",
  WindHail = "deductibles.windHailDeductible",
  WaterDamageDeductible = "deductibles.waterDamageDeductible",
  LossOfUse = "coverageDLossOfUse.value",
  WaterDamage = "waterDamage.value",
  MedicalPayments = "coverageFMedicalPaymentToOthers.value",
  PersonalLiability = "coverageEPersonalLiability.value",
  PremisesLiability = "coverageEPremisesLiability.value",
  InflationGuard = "inflationGuard.value",
  RoofPaymentSchedule = "roofPaymentSchedule.value",
}
export { PackageCoverageAccessor };
